/** Development acquisition window. Timestamps are reconstructed from receipt,
 * not asserted to be synchronized ECG event times. */
export function createRrWindow(windowMs = 60_000, minDurationMs = 30_000) {
  let points: { t: number; rr: number; segment: number }[] = []
  let segment = 0
  let lastReceipt: number | null = null
  return {
    reset() { points = []; segment = 0; lastReceipt = null },
    feed(intervals: number[], now: number) {
      const duration = intervals.reduce((sum, rr) => sum + (Number.isFinite(rr) && rr > 0 ? rr : 0), 0)
      // Do not create a successive difference across an unobserved gap or clock reset.
      if (intervals.length === 0 || (lastReceipt !== null && (now <= lastReceipt || now - lastReceipt > duration + 2000))) segment++
      if (lastReceipt !== null && now <= lastReceipt) points = []
      let t = now - duration
      for (const rr of intervals) {
        if (Number.isFinite(rr) && rr > 0) t += rr
        if (!Number.isFinite(rr) || rr < 300 || rr > 2000) { segment++; continue }
        points.push({ t, rr, segment })
      }
      lastReceipt = now
      points = points.filter(p => p.t > now - windowMs)
      let sumSq = 0, pairs = 0
      for (let i = 1; i < points.length; i++) {
        if (points[i]!.segment !== points[i - 1]!.segment) continue
        sumSq += (points[i]!.rr - points[i - 1]!.rr) ** 2
        pairs++
      }
      const coverageMs = points.reduce((sum, p) => sum + p.rr, 0)
      return {
        rmssdMs: pairs > 0 && coverageMs >= minDurationMs ? Math.sqrt(sumSq / pairs) : null,
        coverageMs,
        count: points.length,
        windowMs,
      }
    },
  }
}
